import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Page, Group, Layout, Button } from "@/comn/components";
import { Grid } from "@/comn/components";
import { comnUtils } from "@/comn/utils";
import { useForm, useToast, useFetch, useModal, useGrid, useAuth, useResource, usePage } from "@/comn/hooks";
import { URLS, APIS, SF_DDLN_XTNS_DTL, SG_UPD_BLL_DTL_LIST } from "./services/OsciBllService"; // 서비스
import { APIS_COMN, SF_COMN_BLL_INFO, SF_COMN_BLL_SRCH } from "@/tz/go/egaz/osci/colt/comn/OsciColtComnService"; // 공통 서비스
import { colEnvs, colUtils } from "@/tz/go/egaz/osci/colt/comn";

/*
 * Deadline Extension Registration
 * !== 데드라인 연장 등록 ==!
 */
export const OSCI0401006S = () => {
    const resource = useResource({
        defaultSchema: [],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003", "auth_osci0021"],
    }); // Page Unique identifier !== 화면 고유 식별자 ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { mode, bllMgmtId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0056" },
            { area: "comnCd", comnCd: "OSC0057" },
            { area: "comnCd", comnCd: "OSC0058" },
            { area: "comnCd", comnCd: "OSC0065" },
            { area: "comnCd", comnCd: "OSC0067" },
            { area: "comnCd", comnCd: "OSC0072" },
            { area: "comnCd", comnCd: "OSC0018" },
            { area: "comnCd", comnCd: "OSC0023" },
            { area: "coCd" },
            { area: "bnkCd" },
        ],
    });

    const [vsbTansad, setVsbTansad] = useState(false);
    const [vsbBll, setVsbBll] = useState(false);
    const [vsbDdlnXtns, setVsbDdlnXtns] = useState(false);
    const [vsbSaveBtn, setVsbSaveBtn] = useState(false);
    const [vsbSrchBtn, setVsbSrchBtn] = useState(false);
    const [vsdDtls, setVsdDtls] = useState(false);

    const [bllDtlList, setBllDtlList] = useState(comnUtils.getGridData([]));

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */

    const form = {
        // Bill Search !== 고지 검색 ==!
        bllSrch: useForm({
            defaultSchema: SF_COMN_BLL_SRCH,
            defaultValues: {},
        }),
        // Bill General !== 고지 일반 ==!
        bllGnrl: useForm({
            defaultSchema: SF_COMN_BLL_INFO,
            defaultValues: {},
        }),
        // Deadline Extension General !== 데드라인 연장 일반 ==!
        ddlnXtnsGnrl: useForm({
            defaultSchema: SF_DDLN_XTNS_DTL,
            defaultValues: {},
        }),
    };

    const today = new Date();

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Bill Detail List !== 고지 상세 목록 ==!
        bllDtlList: useGrid({
            defaultSchema: SG_UPD_BLL_DTL_LIST,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */

    const readyFunc = {
        resetView: () => {
            setVsbBll(false);
            setVsbTansad(false);
            setVsdDtls(false);
        },
        readyBll: (data: any) => {
            console.log("readFunc", data);

            form.bllGnrl.setValues({
                ...data.bllInfo.content,
            });

            form.bllSrch.setValues({
                ...data.bllInfo.content,
            });

            if (data.bllInfo.content != null) {
                setVsbBll(true);
            }
            if (data.bllInfo.content.reffKeyTpCd == "T") {
                setVsbTansad(true);
            }

            if (data.bllInfo.content.reffKeyTpCd == null || data.bllInfo.content.reffKeyTpCd == "") {
                form.bllGnrl.setValue("reffKey", "");
            } else {
                if (data.bllInfo.content.reffKeyTpCd == "T" || data.bllInfo.content.reffKeyTpCd == "B") {
                    form.bllGnrl.setValue(
                        "reffKey",
                        data.bllInfo.content.reffKeyNo1 +
                            "-" +
                            data.bllInfo.content.reffKeyNo2 +
                            "-" +
                            data.bllInfo.content.reffKeyNo3,
                    );
                } else {
                    if (data.bllInfo.content.reffKeyNo4 == null || data.bllInfo.content.reffKeyNo4 == "") {
                        form.bllGnrl.setValue(
                            "reffKey",
                            data.bllInfo.content.reffKeyNo1 +
                                "-" +
                                data.bllInfo.content.reffKeyNo2 +
                                "-" +
                                data.bllInfo.content.reffKeyNo3,
                        );
                    } else {
                        form.bllGnrl.setValue(
                            "reffKey",
                            data.bllInfo.content.reffKeyNo1 +
                                "-" +
                                data.bllInfo.content.reffKeyNo2 +
                                "-" +
                                data.bllInfo.content.reffKeyNo3 +
                                "-" +
                                data.bllInfo.content.reffKeyNo4,
                        );
                    }
                }
            }

            if (data.bllInfo.content.dcltNm != null && data.bllInfo.content.dcltNm != "") {
                form.bllGnrl.setValue(
                    "dcltTinNm",
                    colUtils.setMask(data.bllInfo.content.dcltTin, "tin") + " (" + data.bllInfo.content.dcltNm + ")",
                );
            } else {
                form.bllGnrl.setValue("dcltTinNm", colUtils.setMask(data.bllInfo.content.dcltTin, "tin"));
            }

            if (data.bllInfo.content.exppnImppnNm != null && data.bllInfo.content.exppnImppnNm != "") {
                form.bllGnrl.setValue(
                    "exppnImppnTinNm",
                    colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin") +
                        " (" +
                        data.bllInfo.content.exppnImppnNm +
                        ")",
                );
            } else {
                form.bllGnrl.setValue("exppnImppnTinNm", colUtils.setMask(data.bllInfo.content.exppnImppnTin, "tin"));
            }

            if (data.bllInfo.content.pyerTpCd == "T") {
                if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                    form.bllGnrl.setValue(
                        "pyerMgmtNoNm",
                        colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                            " (" +
                            data.bllInfo.content.pyerNm +
                            ")",
                    );
                } else {
                    form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                }
            } else {
                if (data.bllInfo.content.pyerMgmtNo == null || data.bllInfo.content.pyerMgmtNo == "") {
                    form.bllGnrl.setValue("pyerMgmtNoNm", data.bllInfo.content.pyerNm);
                } else {
                    if (data.bllInfo.content.pyerNm != null && data.bllInfo.content.pyerNm != "") {
                        form.bllGnrl.setValue(
                            "pyerMgmtNoNm",
                            colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin") +
                                " (" +
                                data.bllInfo.content.pyerNm +
                                ")",
                        );
                    } else {
                        form.bllGnrl.setValue("pyerMgmtNoNm", colUtils.setMask(data.bllInfo.content.pyerMgmtNo, "tin"));
                    }
                }
            }

            if (data.bllInfo.content.bllRgsrId && data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue(
                    "bllRgsrIdNm",
                    data.bllInfo.content.bllRgsrId + "/" + data.bllInfo.content.bllRgsrNm,
                );
            } else if (data.bllInfo.content.bllRgsrId) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrId);
            } else if (data.bllInfo.content.bllRgsrNm) {
                form.bllGnrl.setValue("bllRgsrIdNm", data.bllInfo.content.bllRgsrNm);
            }

            if (data.bllInfo.content.bllTpCd && data.bllInfo.content.bllTpCd === "G") setVsdDtls(true);
            if (data.bllInfo.content.bllDtls) {
                setBllDtlList(comnUtils.getGridData(data.bllInfo.content.bllDtls));
            }
        },
    };

    const fetch = {
        // Get Deadline Extension !== 데드라인 연장 조회 ==!
        getDdlnXtns: useFetch({
            api: (data) =>
                APIS.getDdlnXtns(
                    form.bllSrch.getValue("bllTpCd") +
                        "-" +
                        form.bllSrch.getValue("bllSysmCd") +
                        "-" +
                        form.bllSrch.getValue("bllYy") +
                        "-" +
                        form.bllSrch.getValue("bllSrno") +
                        "-" +
                        form.bllSrch.getValue("bllDgr"),
                ),
            onSuccess: (data) => {
                let chkFlag = true;

                if (data.ddlnXtnsDtl.content != null) {
                    if (data.ddlnXtnsDtl.content.bllTpCd == "G") {
                        if (data.ddlnXtnsDtl.content.chkTdd == "FALSE") {
                            modal.openModal({
                                content: "msg.osc.00315", // To extend the payment due date of a Combined Bill, please use the Reuse menu.
                            });
                        } else {
                            modal.openModal({
                                content: "msg.osc.00314", // To extend the payment due date of a Combined Bill, please use the Reuse menu after the current payment due date has passed.
                            });
                        }
                        chkFlag = false;
                    }

                    if (chkFlag && !data.ddlnXtnsDtl.content.ctrlNo) {
                        modal.openModal({
                            content: "msg.osc.00268", // This bill cannot be processed because it does not have a Control Number.
                        });
                        chkFlag = false;
                    }

                    if (chkFlag && data.ddlnXtnsDtl.content.chkTdd == "FALSE") {
                        modal.openModal({
                            content: "msg.osc.00163", // Due date exceeded. The payment due date cannot be extended. Please use the Reuse menu.
                        });
                        chkFlag = false;
                    }

                    if (chkFlag && data.ddlnXtnsDtl.content.chkDspo == "FALSE") {
                        modal.openModal({
                            content: "msg.osc.00164", // Cancelled notice. Payment due date cannot be extended.
                        });
                        chkFlag = false;
                    }

                    if (chkFlag && data.ddlnXtnsDtl.content.chkRcpt == "FALSE") {
                        modal.openModal({
                            content: "msg.osc.00165", // Payment received. Payment due date cannot be extended.
                        });
                        chkFlag = false;
                    }

                    if (chkFlag) {
                        setVsbDdlnXtns(true);
                        setVsbSaveBtn(true);

                        // if (mode === "new") {
                        //     const { ddlnXtnsDt, ddlnXtnsRsn, ...restDdlnXtnsDtl } = data.ddlnXtnsDtl.content;
                        //     form.ddlnXtnsGnrl.setValues({
                        //         ...restDdlnXtnsDtl,
                        //     });
                        // } else {
                        form.ddlnXtnsGnrl.setValues({
                            ...data.ddlnXtnsDtl.content,
                        });
                        // }
                    }
                } else {
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });
                }
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),
        // Get Bill !== 고지서 조회 ==!
        getBll: useFetch({
            api: (data) => APIS_COMN.getBll(bllMgmtId),
            // enabled: !!bllNo,
            onSuccess: (data) => {
                readyFunc.readyBll(data);

                fetch.getDdlnXtns.fetch();
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),
        // Get Bill Search !== 고지서 검색 조회 ==!
        getBllSrch: useFetch({
            api: (data) => APIS_COMN.getBllDtl(form.bllSrch.getValues()),
            onSuccess: (data) => {
                if (data.bllInfo.content != null) {
                    readyFunc.resetView();
                    readyFunc.readyBll(data);
                    form.ddlnXtnsGnrl.setValues(data.bllInfo.content);

                    fetch.getDdlnXtns.fetch();
                } else {
                    modal.openModal({
                        content: "msg.osc.00182", // Please check Bill No.
                    });
                }
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.osc.00182", // Please check Bill No.
                });
            },
            showToast: true,
        }),
        // Save Deadline Extension !== 데드라인 연장 저장 ==!
        saveDdlnXtns: useFetch({
            api: (data, save_mode) =>
                APIS.saveDdlnXtns({ ...data, bllNo: data.bllNo ? data.bllNo : auth.get("tin"), auth, mode: save_mode }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006",
                    onConfirm: () => {
                        navigate(
                            `${URLS.osci0401005q}/${data.ddlnXtnsSaveResDto.content.bllTpCd}-${data.ddlnXtnsSaveResDto.content.bllSysmCd}-${data.ddlnXtnsSaveResDto.content.bllYy}-${data.ddlnXtnsSaveResDto.content.bllSrno}-${data.ddlnXtnsSaveResDto.content.bllDgr}`,
                        );
                    },
                    onCancel: () => {
                        navigate(`${URLS.osci0401006s}/${form.ddlnXtnsGnrl.getValues().bllNo}`);
                    },
                });
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.ddlnXtnsGnrl.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: "msg.osc.00015",
                });
            },
        }),
    };

    const isInvalidExpireDate = (currentDate?: string, newDate?: string): boolean => {
        if (!currentDate || !newDate) {
            return false;
        }
        return comnUtils.compareDate(newDate, currentDate) !== -1;
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Save Deadline Extension !== 데드라인 연장 저장 ==!
        saveDdlnXtns: form.ddlnXtnsGnrl.handleSubmit(
            () => {
                const lastPayDdlnDt = form.bllGnrl.getValue("lastPayDdlnDt");
                const xtnsDt = form.ddlnXtnsGnrl.getValue("ddlnXtnsDt");
                const todayStr = comnUtils.dateToString(today, "date");
                if (isInvalidExpireDate(lastPayDdlnDt, xtnsDt) || isInvalidExpireDate(todayStr, xtnsDt)) {
                    modal.openModal({
                        content: "msg.osc.00285", //The extended expiration date must be later than the current expiration date.
                    });
                } else {
                    const data = { ...form.ddlnXtnsGnrl.getValues() };

                    var save_mode = mode;
                    if (data.ddlnXtnsStatCd == "R") {
                        save_mode = "updt";
                    }

                    modal.openModal({
                        content: "msg.osc.00090",
                        onConfirm: () => {
                            fetch.saveDdlnXtns.fetch(data, save_mode);
                        },
                    });
                }
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.osc.00003" });
            },
        ),
        // Get Deadline Extension Search !== 데드라인 연장 검색 조회 ==!
        getDdlnXtnsSrch: () => {
            form.bllSrch.handleSubmit((data) => {
                let bllNo = form.bllSrch.getValue("bllNo");

                if (bllNo) {
                    bllNo = bllNo.trim(); // 앞뒤 공백 제거

                    // "X-XXXX-XX-XXXXXXX-X"(bllMgmtId 마스크) 패턴이면 '-' 제거
                    if (/^[A-Za-z0-9]-[A-Za-z0-9]{4}-[A-Za-z0-9]{2}-[A-Za-z0-9]{7}-[A-Za-z0-9]$/.test(bllNo)) {
                        bllNo = bllNo.replaceAll("-", "");
                    }

                    form.bllSrch.setValue("bllNo", bllNo); // 정규화된 값을 폼에 반영
                }

                let bllTpCd = form.bllSrch.getValue("bllTpCd");
                let bllSysmCd = form.bllSrch.getValue("bllSysmCd");
                let bllYy = form.bllSrch.getValue("bllYy");
                let bllSrno = form.bllSrch.getValue("bllSrno");
                let bllDgr = form.bllSrch.getValue("bllDgr");
                // Validation Check !== 밸리데이션 체크 ==!
                if (!!!bllNo && (!!!bllTpCd || !!!bllSysmCd || !!!bllYy || !!!bllSrno || !!!bllDgr)) {
                    modal.openModal({
                        content: "msg.osc.00281",
                    });
                } else {
                    fetch.getBllSrch.fetch();
                }
            })();
        },
    };

    const render = {
        grid_bllDtlList: {
            head: {},
            cell: {
                bllNo: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <span>
                            {`${rowValues.bllTpCd}-${rowValues.bllSysmCd}-${rowValues.bllYy}-${rowValues.bllSrno}-${rowValues.bllDgr}`}
                        </span>
                    );
                },
            },
            edit: {},
        },
    };

    useEffect(() => {
        if (mode == "updt") {
            form.bllSrch.setEditable(false);
            fetch.getBll.fetch();
        } else if (mode == "new") {
            setVsbSrchBtn(true);
        }

        form.bllGnrl.setEditable(false);
        form.ddlnXtnsGnrl.setEditable(true);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bllSrch.schema.bllNo} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Label {...form.bllSrch.schema.bllMgmtId}></Group.Label>
                            <Group.Field size={4}>
                                <Group.Control
                                    {...form.bllSrch.schema.bllTpCd}
                                    onPaste={(e: any) => {
                                        e.preventDefault();
                                        const data = e.clipboardData.getData("Text").replaceAll("-", "");

                                        form.bllSrch.setValue("bllTpCd", data.substring(0, 1));
                                        form.bllSrch.setValue("bllSysmCd", data.substring(1, 5));
                                        form.bllSrch.setValue("bllYy", data.substring(5, 7));
                                        form.bllSrch.setValue("bllSrno", data.substring(7, 14));
                                        form.bllSrch.setValue("bllDgr", data.substring(14, 15));
                                    }}
                                />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllSysmCd} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllSrno} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.bllSrch.schema.bllDgr} />
                            </Group.Field>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.bllSrch.reset();
                                }}
                            ></Button>
                        </Layout.Left>
                        <Layout.Right>
                            {vsbSrchBtn && (
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.getDdlnXtnsSrch();
                                    }}
                                ></Button>
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            {vsbTansad && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_TANSAD_GNRL"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.tansadNo} />
                                <Group.Control {...form.bllGnrl.schema.tansadDt} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.regm} />
                                <Group.Control {...form.bllGnrl.schema.csclPlnCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.exppnImppnTinNm} />
                                <Group.Control {...form.bllGnrl.schema.dcltTinNm} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.bllGnrl.schema.dclrPrcssSttsCd} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {vsbBll && (
                <>
                    <Group>
                        <Group.Body>
                            <Group.Title title={"L_BLL_GNRL"} titleSize={2}></Group.Title>
                            <Group.Section>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllNo} />
                                    <Group.Control {...form.bllGnrl.schema.bllDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.ctrlNo} />
                                    <Group.Control {...form.bllGnrl.schema.zmpDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.bllTpCdSec} />
                                    <Group.Control {...form.bllGnrl.schema.bllStatCd} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.pyerMgmtNoNm} />
                                    <Group.Control {...form.bllGnrl.schema.bllRgsrIdNm} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.reffKeyTpCd} />
                                    <Group.Control {...form.bllGnrl.schema.reffKey} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.feeAmt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.payDdlnDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsDt} />
                                </Group.Row>
                                <Group.Row>
                                    <Group.Control {...form.bllGnrl.schema.xtnsDt} />
                                    <Group.Control {...form.bllGnrl.schema.lastDdlnXtnsRsn} />
                                </Group.Row>
                            </Group.Section>
                        </Group.Body>
                    </Group>
                    {vsdDtls && (
                        <Group>
                            <Group.Body>
                                {" "}
                                <Layout direction="row">
                                    <Layout.Left>
                                        <Group.Title title={"T_BLL_DTL_1"} titleSize={2}></Group.Title>
                                    </Layout.Left>
                                </Layout>
                                <Grid {...grid.bllDtlList.grid} data={bllDtlList} render={render.grid_bllDtlList} />
                            </Group.Body>
                        </Group>
                    )}
                </>
            )}
            {vsbDdlnXtns && (
                <Group>
                    <Group.Body>
                        <Group.Title title={"L_DDLN_XTNS"} titleSize={2}></Group.Title>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.ddlnXtnsGnrl.schema.ddlnXtnsDt} />
                                <Group.Control {...form.ddlnXtnsGnrl.schema.ddlnXtnsRsn} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0401004q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    {vsbSaveBtn && <Button role="save" onClick={handler.saveDdlnXtns}></Button>}
                </Layout.Right>
            </Layout>
        </Page>
    );
};
